<template>
  <div class="containerContract">
    <b-card>
      <div style="font-size: 12px">
        <div class="title">
          <span>Vincular Contrato ao Aluno</span>
        </div>
        <div class="rowContainer">
          <span>
            <b-icon-person-lines-fill></b-icon-person-lines-fill> Informações
            Gerais</span
          >
          <div class="rowContent">
            <InputInfinit
              label="Alunos"
              :dataInput.sync="dataContract.idStudent"
              :onSearch="fillCustomerComboBoxWithPaginate"
              @selectItem="selectStudent($event)"
            />
            <InputSelect
              label="Cursos"
              :enableIconCreate="false"
              :items="allCourses"
              valueField="id"
              textField="courseName"
              @selectedIten="selectCourse($event)"
              :dataSelect.sync="dataContract.courseId"
              ref="idCourse"
            />
          </div>
        </div>
        <div class="rowContainer">
          <span> <b-icon-cash-stack /> Pagamento Curso</span>
          <div class="rowContent" style="flex-direction: column">
            <div
              style="
                display: flex;
                flex-direction: column;
                justify-content: flex-start;
                bottom: 10px;
                position: relative;
                align-items: center;
              "
            >
              <div
                class="text"
                style="color: #666; font-size: 16px; padding-bottom: 10px"
              >
                Onde estudou:
              </div>
              <div class="radio-input">
                <label class="cyberpunk-checkbox-label">
                  <input
                    type="checkbox"
                    v-model="dataStudent.isStudentOfOmega"
                    class="cyberpunk-checkbox"
                  />
                  Aluno Ômega</label
                >
                <label class="cyberpunk-checkbox-label">
                  <input
                    type="checkbox"
                    v-model="dataStudent.isOldStudentOfOmega"
                    class="cyberpunk-checkbox"
                  />
                  Ex-Aluno Ômega</label
                >
                <label class="cyberpunk-checkbox-label">
                  <input
                    type="checkbox"
                    v-model="dataStudent.isSchoolPublic"
                    class="cyberpunk-checkbox"
                  />
                  Escola pública</label
                >
                <label class="cyberpunk-checkbox-label">
                  <input
                    type="checkbox"
                    v-model="dataStudent.isResideForaVicosa"
                    class="cyberpunk-checkbox"
                  />
                  Reside fora de viçosa</label
                >
              </div>
            </div>
          </div>
          <div class="rowContent">
            <div class="selectPlus">
              <label class="fixedSelect">Tipo de pagamento do curso:</label>
              <b-form-select
                value-field="value"
                text-field="text"
                class="borderInput shadow-none"
                :options="payments"
                v-model="dataContract.paymentCourses"
                size="sm"
              />
            </div>
            <div class="selectPlus">
              <label class="fixedSelect"> Tipo de pagamento do Material:</label>
              <b-form-select
                value-field="value"
                text-field="text"
                class="borderInput shadow-none"
                :options="payments"
                v-model="dataContract.paymentMaterial"
                size="sm"
              />
            </div>
          </div>
        </div>
        <div class="rowContainer">
          <span> <b-icon-info-circle-fill /> Dados do Contrato</span>
          <div class="rowContent">
            <div>
              <p>@nomeAluno = Nome do aluno</p>
              <p>@nomeCurso = Nome do curso</p>
              <p>@precoCurso = Preço do curso</p>
              <p>@precoMaterialCurso = Preço do material externo</p>
              <p>@precoMaterialOmegaCurso = Preço do material interno</p>
            </div>
            <div>
              <p>@dataInicioCurso = Data de início do curso</p>
              <p>@dataFimCurso = Data de fim do curso</p>
              <p>@nomeContratante = Nome do contratante</p>
              <p>@cpfContratante = CPF do contratante</p>
              <p>@rgContratante = RG do contratante</p>
            </div>
            <div>
              <p>@emailContratante = Email do contratante</p>
              <p>@nomeFiador = Nome do fiador</p>
              <p>@cpfFiador = CPF do fiador</p>
              <p>@rgFiador = RG do fiador</p>
              <p>@emailFiador = Email do fiador</p>
            </div>
          </div>
        </div>
        <div class="rowContainer" style="margin-bottom: 100px">
          <div class="rowContent">
            <div class="pa-md" style="max-width: 900px">
              <div class="expansion-item">
                <div
                  :class="['header', { 'bg-primary text-white': isOpen }]"
                  @click="toggleEditor"
                >
                  <span> <b-icon-plus-square-fill /> Editor de contrato</span>
                  <i class="material-icons" :class="{ 'text-white': isOpen }">
                  </i>
                </div>
                <transition name="slide">
                  <div v-if="isOpen" class="editor-content" @focusin.stop>
                    <vue-editor
                      v-model="editorContent"
                      :editor-toolbar="toolbarOptions"
                      :editor-fonts="fonts"
                    />
                  </div>
                </transition>
              </div>
            </div>
          </div>
        </div>
        <div class="content-btn-fixed">
          <b-button class="btnsSaveNeutral" @click="clearInputs"
            >Novo <b-icon-arrow-clockwise class="ml-1"></b-icon-arrow-clockwise
          ></b-button>
          <b-button class="btnsSave" @click="updateContract">Salvar </b-button>
        </div>
      </div>
    </b-card>
  </div>
</template>

<script>
import { VueEditor } from "vue2-editor";
import InputSelect from "../UI/CustomInputs/InputSelect.vue";
import CourseService from "../../services/course";
import { contractDefault } from "../../common";
import InputInfinit from "../UI/CustomInputs/InputInfinit.vue";

export default {
  components: {
    VueEditor,
    InputSelect,
    InputInfinit,
  },
  data() {
    return {
      dataStudent: {
        address: "",
        birthDate: "",
        cep: "",
        city: "",
        cpf: "",
        createdAt: "",
        district: "",
        email: "",
        id: "",
        isOldStudentOfOmega: "",
        isResideForaVicosa: "",
        isSchoolPublic: "",
        isStudentOfOmega: "",
        name: "",
        number: "",
        oldSchool: "",
        phone: "",
        rg: "",
        studentCourse: [],
        uf: null,
        updatedAt: "",
        userId: 95,
        responsibles: [],
      },
      dataContract: {
        id: "",
        courseId: "",
        idStudent: "",
        paymentCourses: "",
        paymentMaterial: "",
        observation: "",
      },
      allStudents: [],
      allCourses: [],
      selectedRadio: "",
      payments: [
        { value: "A Vista", text: "À vista (Pix/Transferência/Dinheiro)" },
        { value: "A Prazo", text: "A prazo (Parcelamento - Boleto Bancário)" },
      ],
      isOpen: false,
      editorContent: contractDefault,
      toolbarOptions: [
        ["bold", "italic", "underline", "strikeThrough"],
        [{ align: [] }],
        ["link", "image"],
        [{ list: "ordered" }, { list: "bullet" }],
        [{ script: "sub" }, { script: "super" }],
        [{ indent: "-1" }, { indent: "+1" }],
        ["clean"],
      ],
      fonts: {
        arial: "Arial",
        times_new_roman: "Times New Roman",
        verdana: "Verdana",
      },
      selectedCourse: "",
    };
  },
  methods: {
    toggleEditor() {
      this.isOpen = !this.isOpen;
    },
    async studentsCombobox() {
      try {
        const { data } = await CourseService.comboboxStudents();
        this.allStudents = data;
      } catch (error) {
        console.error("Erro ao carregar alunos:", error);
      }
    },
    async fillCustomerComboBoxWithPaginate(q, page = 1) {
      try {
        const response = await CourseService.getStudentBy(
          "name",
          q || "",
          page,
          20
        );

        return response.data;
      } catch (error) {
        this.$toast.open({
          message:
            error?.response?.data?.message ||
            "Ocorreu um problema ao listar os alunos",
          type: "info",
        });
        return [];
      }
    },
    async updateContract() {
      try {
        await CourseService.updateVinculoContract(
          this.dataStudent.id,
          this.selectedCourse.courseId,
          this.editorContent
        );
        this.clearInputs();
        this.$toast.open({
          message: "Contrato atualizado com sucesso!",
          type: "success",
        });
      } catch (error) {
        console.error(error);
      }
    },
    async selectStudent(studentObj) {
      if (!studentObj) {
        this.allCourses = [];
        this.dataStudent = {};
        return;
      }

      try {
        this.spinGeneral = true;
        const result = await CourseService.getStudentById(studentObj.id);
        Object.assign(this.dataStudent, result.data);
        this.allCourses = this.dataStudent.studentCourse;
      } catch (error) {
        console.log(error);

        return this.$toast.open({
          message: "Ocorreu um erro ao buscar os cursos do aluno!",
          type: "error",
        });
      } finally {
        this.spinGeneral = false;
      }
    },
    async selectCourse(idCourse) {
      try {
        this.spinGeneral = true;
        this.selectedCourse = this.allCourses.find(
          (course) => course.id === idCourse
        );

        const contract = await CourseService.getContractByCourse(
          this.dataStudent.id,
          this.selectedCourse.courseId
        );

        this.editorContent = contract.data.data.data;
        this.dataContract.paymentCourses = this.selectedCourse.paymentCourse;
        this.dataContract.paymentMaterial = this.selectedCourse.paymentMaterial;
      } catch (error) {
        console.log(error);
        return this.$toast.open({
          message: "Ocorreu um erro!",
          type: "error",
        });
      } finally {
        this.spinGeneral = false;
      }
    },
    clearInputs() {
      this.dataContract = {
        id: "",
        courseId: "",
        idStudent: "",
        paymentCourses: "",
        paymentMaterial: "",
        observation: "",
      };
      this.dataStudent = {
        address: "",
        birthDate: "",
        cep: "",
        city: "",
        cpf: "",
        createdAt: "",
        district: "",
        email: "",
        id: "",
        isOldStudentOfOmega: "",
        isResideForaVicosa: "",
        isSchoolPublic: "",
        isStudentOfOmega: "",
        name: "",
        number: "",
        oldSchool: "",
        phone: "",
        rg: "",
        studentCourse: [],
        uf: null,
        updatedAt: "",
        userId: "",
        responsibles: [],
      };
      this.selectedCourse = "";
      this.editorContent = contractDefault;
      this.$refs.idStudent.valueItems = "";
      this.$refs.idCourse.valueItems = "";
    },
  },
  mounted() {
    this.studentsCombobox();
  },
};
</script>
<style scoped>
.pa-md {
  padding: 16px;
  width: 100%;
}

.editor-content {
  font-size: 13px !important;
}
.expansion-item {
  cursor: pointer;
  border: 1px solid #ccc;
  border-radius: 4px;
}

.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px;
  background-color: #f5f5f5;
  border-bottom: 1px solid #ccc;
}

.editor-content {
  padding: 16px;
}

.material-icons {
  font-size: 13px !important;
}
.ql-editor {
  font-size: 13px !important;
}
.containerContract {
  display: flex;
  justify-content: center;
  padding-top: 70px;
  width: 80%;
  margin: 0 auto;
}
.form-control-sm {
  height: 28px;
  padding: 0.25rem 0.25rem;
  font-size: 12px;
  line-height: 1.3;
  border-radius: 0.2rem;
}

.content-btn-fixed {
  width: 100%;
  padding: 0.7% 0px;
  left: 60px;
  position: fixed;
  bottom: 0;
  display: flex;
  justify-content: space-around;
  align-items: center;
  background-color: #ffff;
  z-index: 10;
  box-shadow: -2px -2px 4px 0 rgba(0, 0, 0, 0.102);
}

.custom-select {
  display: inline-block;
  width: 100%;
  height: calc(1.5em + 0.75rem + 2px);
  padding: 0.375rem 1.75rem 0.375rem 0.75rem;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: #495057;
  vertical-align: middle;
  background: #fff url(https://cdn-icons-png.flaticon.com/512/271/271210.png)
    right 0.75rem center / 8px 10px no-repeat !important;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
}

.form-group {
  margin-bottom: 0.2rem;
}

span {
  font-weight: bold;
  cursor: context-menu;
}

.user-label {
  position: absolute;
  left: 10px;
  font-size: 11px;
  bottom: 5px;
  pointer-events: none;
  transform: translateY(0.5rem);
  transition: 150ms cubic-bezier(0.4, 0, 0.2, 1);
  white-space: nowrap !important;
  text-overflow: ellipsis;
  color: #666360;
}

.iconSelect {
  position: absolute;
  right: 0px !important;
  z-index: 10;
  background-color: rgb(213, 213, 213);
  color: whitesmoke;
  height: 30px;
  width: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 0.25rem;
  cursor: context-menu;
}

.contentImg {
  display: flex;
  width: 100%;
  border: 1px solid rgb(230, 230, 230);
  border-radius: 5px;
  padding: 20px 10px;
  margin-bottom: 10px;
  gap: 20px;
  position: relative;
}

.leftImg {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.rightImg {
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: center;
  width: 80%;
  position: relative;
}

.image-container {
  width: 20%;
}

.input-container {
  width: 80%;
}

.contentImg .logo:hover {
  background-color: #f5f5f5;
  cursor: pointer;
}

.contentImg .logo__img {
  max-height: 120px;
  max-width: 200px;
}

.input-group {
  width: 100%;
}

.user-label {
  position: absolute;
  left: 10px;
  font-size: 11px;
  bottom: 5px;
  pointer-events: none;
  transform: translateY(0.5rem);
  transition: 150ms cubic-bezier(0.4, 0, 0.2, 1);
  white-space: nowrap !important;
  text-overflow: ellipsis;
  color: #666360;
}

.contentImg > div {
  display: flex;
}

.contentImg .logo {
  height: 135px;
  width: 210px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: transparent;
  border-radius: 7px;
  border: solid 1px rgb(223 223 223);
  color: #aaa;
  cursor: pointer;
  margin: 0;
}

.contentImg .logo:hover {
  background-color: #f5f5f5;
  cursor: pointer;
}

.contentImg .logo__img {
  max-height: 120px;
  max-width: 200px;
}

.input-group {
  width: 100%;
}

.logo_img_not {
  height: 148px;
  width: 200px;
  max-height: 150px;
  max-width: 200px;
  cursor: pointer;
}

#input_file {
  display: none;
}

.cyberpunk-checkbox {
  appearance: none;
  width: 15px;
  height: 15px;
  border: 2px solid #0188c8;
  border-radius: 5px;
  background-color: transparent;
  display: inline-block;
  position: relative;
  margin-right: 10px;
  cursor: pointer;
}

.cyberpunk-checkbox:before {
  content: "";
  background-color: #0188c8;
  display: block;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%) scale(0);
  width: 10px;
  height: 10px;
  border-radius: 3px;
  transition: all 0.3s ease-in-out;
}

.cyberpunk-checkbox:checked:before {
  transform: translate(-50%, -50%) scale(1);
}

.cyberpunk-checkbox-label {
  font-size: 14px;
  color: #454545;
  cursor: pointer;
  user-select: none;
  display: flex;
  align-items: center;
}

.tamanhoBotaoOpenCard {
  color: black;
  font-size: 16px;
  height: 30px;
  display: flex;
  align-items: center;
}

.tamanhoBotaoOpenCardFinaly {
  color: black;
  font-size: 16px;
  height: 30px;
  display: flex;
  align-items: center;
}

.iconCadTransportadora {
  display: flex;
  justify-content: space-between;
}

.btnCadTransportadora {
  cursor: pointer;
}

.cardDadosMdfe {
  padding-bottom: 15px !important;
  border-radius: 5px !important;
  border: 1px solid rgba(232, 231, 231, 0.788);
  background-color: #f9f9f94d !important;
  padding: 0px 0px 0px 0px !important;
  border-radius: 5px !important;
  width: 100%;
}

.cardDadosMdfeBorda {
  border-radius: 5px !important;
  margin-top: 25px !important;
  margin-bottom: 20px;
}

.cardDadosMdfeBordaDupli {
  border-radius: 5px !important;
  margin-top: 25px !important;
  margin-bottom: 20px;
}

.whatsapp {
  width: 20px;
  height: 20px;
}

.imageCourse {
  width: 100%;
  height: 100%;
  object-fit: contain;
  border-radius: 7px !important;
}

.bcsCep {
  display: flex;
  height: 30px;
  position: absolute;
  right: 0px;
  font-size: 11px;
  z-index: 2;
  cursor: pointer;
  color: black;
  border-radius: 5px;
  border: none;
  background: #c3c3c3;
  align-items: center;
}
.navbar-nav {
  margin-left: 60px !important;
}
.validRed {
  font-size: 13px;
  color: red;
}

.user-label-ob {
  position: absolute;
  left: 40px;
  font-size: 11px;
  pointer-events: none;
  transform: translateY(0.5rem);
  transition: 150ms cubic-bezier(0.4, 0, 0.2, 1);
  white-space: nowrap !important;
  text-overflow: ellipsis;
  color: #666360;
}
.user-label-img {
  font-size: 11px;
  pointer-events: none;
  white-space: nowrap !important;
  text-overflow: ellipsis;
  color: #666360;
  margin-top: 0.3rem;
}

.input {
  font-size: 12px !important;
  width: 100%;
}

.input:focus ~ label,
.input:valid ~ label {
  transform: translateY(-50%) scale(0.8);
  background-color: #ffffff;
  padding: 0 0.1em;
  font-weight: 600;
}

.validRed::before {
  color: blue;
}
.selectPlus {
  position: relative;
  width: 40%;
  display: flex;
  flex-direction: row;
  gap: 20px;
  align-items: center;
}

.radio-input {
  display: flex;
  align-items: center;
  width: 100%;
  justify-content: space-evenly;
}

.selectPlus {
  position: relative;
  width: 100%;
  display: flex;
  flex-direction: row;
  gap: 20px;
  align-items: center;
}

.fixedSelect {
  position: absolute;
  margin-bottom: 0px;
  font-size: 10px;
  bottom: 22px;
  left: 11px;
  z-index: 2;
  text-transform: capitalize;
  color: rgb(85, 81, 81);
  background-color: white;
  font-weight: 600;
}

.selectPlusImg {
  position: relative;
  width: 23%;
  display: flex;
  flex-direction: row;
  gap: 20px;
  align-items: center;
}

.fixedSelect2 {
  position: absolute;
  margin-bottom: 0px;
  font-size: 11px;
  bottom: 22px;
  left: 11px;
  z-index: 2;
  text-transform: capitalize;
  color: rgb(85, 81, 81);
  background-color: white;
  font-weight: 600;
}

.fixedSelect3 {
  position: relative;
  margin-bottom: 0px;
  font-size: 10px;
  bottom: 40px;
  left: 11px;
  z-index: 2;
  text-transform: capitalize;
  color: rgb(85, 81, 81);
  background-color: white;
  font-weight: 600;
}

.custom-select {
  display: inline-block;
  width: 100%;
  height: calc(1.5em + 0.75rem + 2px);
  padding: 0.375rem 1.75rem 0.375rem 0.75rem;
  font-size: 11px !important;
  font-weight: 400;
  line-height: 1.5;
  color: #495057;
  vertical-align: middle;
  background: none;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
}

.borderInput {
  font-size: 12px;
  height: 30px;
  border: 1px solid #d5d3d3;
  border-radius: 5px;
  outline: none;
  transition: ease-in 0.1s all;
  padding-left: 5px;
  padding-right: 4px;
  color: #5c5855;
}

.borderInput:focus {
  border: 1px solid #505050;
}

.isInvalidInput:focus {
  border: solid 1px rgba(204, 21, 21, 0.583) !important;
  transition: ease-in all 0.1s;
  box-shadow: 0 0 2px 1px rgba(204, 21, 21, 0.583) !important;
}

.title {
  font-size: 16px;
  color: rgb(95, 95, 95);
  display: flex;
  margin-bottom: 20px;
  margin-right: 20px;
  border-bottom: 1px solid rgb(230, 230, 230);
  justify-content: space-between;
}

.title span {
  font-weight: 600;
}

.requiredFields {
  font-size: 11px;
  color: red;
}

.rowContainer {
  border: 1px solid rgb(230, 230, 230);
  border-radius: 5px;
  display: flex;
  flex-direction: column;
  padding: 10px 10px 10px 10px;
  background: #f9f9f94d;
  margin-bottom: 10px;
}

.rowContainer span {
  font-weight: 600;
}

p {
  margin-bottom: 0rem !important;
}

.rowContent {
  display: flex;
  width: 100%;
  padding: 10px 0 5px 0;
  justify-content: space-between;
  gap: 10px;
}
.rowContentImg {
  display: flex;
  align-items: center;
  width: 100%;
  padding: 10px 0 5px 0;
  gap: 40px;
}

.rowObservation {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: 40px;
  padding: 10px 0 5px 0;
}

.btnsContainer {
  gap: 20px;
  display: flex;
  width: 100%;
  justify-content: space-between;
  margin-top: 2rem;
}

.btnsSave {
  border-radius: 5px;
  background-color: #0188c8;
  width: 165px;
  border: none;
  color: white;
  font-size: 12px;
  font-weight: 600;
}

.btnsSaveNeutral {
  border-radius: 5px;
  background-color: #d7d7d7;
  width: 165px;
  border: none;
  color: rgb(0, 0, 0);
  font-size: 12px;
  font-weight: 600;
}

.input-group {
  width: 30%;
}

.input-group-img {
  width: 20%;
  height: 30px;
}

.input-group-ob {
  width: 65%;
}

.card-body {
  flex: 1 1 auto;
  min-height: 1px;
  padding: 0 1rem 0 1rem;
}

.card {
  border: none !important;
}

@media screen and (max-width: 700px) {
  .rowContent {
    display: flex;
    width: 100%;
    padding: 5px 0 5px 0;
    justify-content: space-between;
    gap: 10px;
    flex-direction: column;
  }

  .contentImg {
    flex-direction: column;
  }

  .rightImg {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    position: relative;
    flex-direction: column;
  }

  .rowContentImg {
    display: flex;
    width: 100%;
    gap: 0px;
    flex-direction: column;
    align-items: center;
  }

  .input-group {
    width: 100%;
  }

  .input-group-img {
    width: 100%;
    height: auto;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }

  .borderInput {
    width: 100%;
  }

  .selectPlusImg {
    width: 100%;
  }

  .selectPlus {
    position: relative;
    width: 100%;
    display: flex;
    flex-direction: row;
    gap: 20px;
    align-items: center;
  }
}
</style>
